import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import ChangeChip from '../ChangeChip';
import FluidValue from '../FluidValue';

const BreakdownRow = ({ a, b, showB, periodColours, text }) => {
    if (showB) {
        return (
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell width="10%">
                    {text}
                </TableCell>
                <TableCell width="40%">
                    <FluidValue
                        typographyVariant="h5"
                        colour={periodColours[0]}
                        value={a}
                        valueType="rate"
                        accuracy={3}
                        textAlign="center"
                    />
                </TableCell>
                <TableCell width="40%">
                    <FluidValue
                        typographyVariant="h5"
                        colour={periodColours[1]}
                        value={b}
                        valueType="rate"
                        accuracy={3}
                        textAlign="center"
                    />
                </TableCell>
                <TableCell width="10%">
                    <ChangeChip
                        change={b - a}
                        a={a}
                        b={b}
                    />
                </TableCell>
            </TableRow>
        );
    }

    return (
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell width="10%">
                {text}
            </TableCell>
            <TableCell>
                <FluidValue
                    typographyVariant="h5"
                    colour={periodColours[0]}
                    value={a}
                    valueType="rate"
                    accuracy={3}
                    textAlign="right"
                />
            </TableCell>
        </TableRow>
    );
};

export default BreakdownRow;